import { useContext } from 'react';
import { AuthContext } from '@/common/contexts/auth-context';

export function useAuth() {
  return useContext(AuthContext);
}
